import { render } from "./MappingReferencesView.vue?vue&type=template&id=662f805a"
import script from "./MappingReferencesView.vue?vue&type=script&lang=js"
export * from "./MappingReferencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__